import { z } from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

// Admin-triggered backfill / reset of a loan's typed-postings ledger.
//
//   - `derive`   — project source records to a fresh ledger. Throws
//                  if the ledger isn't empty (caller must `clear`
//                  first, or use `rederive`).
//   - `clear`    — wipe the ledger and provenance markers. No
//                  derivation runs.
//   - `rederive` — `clear` then `derive`, atomically.
//
// See `handleDeriveLedger` for the handler and
// `deriveLedgerFromSnapshot` for the underlying pure projection.
export const DeriveLedgerEvent = BaseLoanEvent.extend({
  type: z.literal('deriveLedger'),
  mode: z.enum(['derive', 'clear', 'rederive']),
});
export type DeriveLedgerEvent = z.infer<typeof DeriveLedgerEvent>;
